import React, { useState } from 'react';

// Input de "etiquetas": el usuario escribe un valor y lo agrega con Enter, coma
// o al salir del campo. Se usa para los dominios y las URLs permitidas de un
// token externo, donde la cantidad de valores es variable.
const FormTagsInput = ({
  id,
  label,
  value = [],
  onChange,
  placeholder = '',
  error = null,
  sugerencias = [],
  ayuda = null,
  validar = null,
  normalizar = null,
}) => {
  const [texto, setTexto] = useState('');
  const [errorLocal, setErrorLocal] = useState(null);

  const agregar = crudo => {
    const recortado = (crudo || '').trim().replace(/,$/, '');
    // Si el padre da un normalizador, se guarda el valor ya normalizado para que la
    // etiqueta muestre exactamente lo que se va a guardar en el API.
    const limpio = normalizar ? normalizar(recortado) : recortado;

    if (limpio === '') return true;

    if (value.includes(limpio)) {
      setErrorLocal(`"${limpio}" ya está en la lista`);
      return false;
    }

    if (validar) {
      const mensaje = validar(limpio);
      if (mensaje) {
        setErrorLocal(mensaje);
        return false;
      }
    }

    setErrorLocal(null);
    onChange([...value, limpio]);
    return true;
  };

  const quitar = indice => {
    setErrorLocal(null);
    onChange(value.filter((_, i) => i !== indice));
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ',') {
      event.preventDefault();
      if (agregar(texto)) setTexto('');
      return;
    }

    if (event.key === 'Backspace' && texto === '' && value.length > 0) {
      quitar(value.length - 1);
    }
  };

  const handleBlur = () => {
    if (agregar(texto)) setTexto('');
  };

  const listaId = `${id}-sugerencias`;
  const noUsadas = sugerencias.filter(s => !value.includes(s));
  const mensaje = errorLocal || (error ? error.message : null);

  return (
    <div className="form-group">
      {label && <label htmlFor={id}>{label}</label>}

      <div className="form-control" style={{ height: 'auto', minHeight: '38px', paddingTop: '4px', paddingBottom: '4px' }}>
        <div className="d-flex flex-wrap align-items-center" style={{ gap: '4px' }}>
          {value.map((tag, indice) => (
            <span
              key={tag}
              className="badge badge-pill badge-light border"
              style={{ fontSize: '13px', fontWeight: 'normal', padding: '5px 8px' }}>
              {tag}
              <i
                className="fa fa-times ml-2"
                role="button"
                title="Quitar"
                style={{ cursor: 'pointer', color: '#93000A' }}
                onClick={() => quitar(indice)}
              />
            </span>
          ))}

          <input
            id={id}
            type="text"
            list={noUsadas.length ? listaId : undefined}
            value={texto}
            placeholder={value.length ? '' : placeholder}
            onChange={event => {
              setTexto(event.target.value);
              setErrorLocal(null);
            }}
            onKeyDown={handleKeyDown}
            onBlur={handleBlur}
            style={{ border: 'none', outline: 'none', flex: 1, minWidth: '180px', fontSize: '14px' }}
          />
        </div>
      </div>

      {noUsadas.length > 0 && (
        <datalist id={listaId}>
          {noUsadas.map(sugerencia => (
            <option key={sugerencia} value={sugerencia} />
          ))}
        </datalist>
      )}

      {mensaje && <small className="text-danger d-block mt-1">{mensaje}</small>}
      {!mensaje && ayuda && <small className="text-muted d-block mt-1">{ayuda}</small>}
    </div>
  );
};

export default FormTagsInput;
